/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Ingredient_Name_PlaceholderInputs */

const en_editor_ingredient_name_placeholder = /** @type {(inputs: Editor_Ingredient_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. Onion`)
};

const de_editor_ingredient_name_placeholder = /** @type {(inputs: Editor_Ingredient_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`z. B. Zwiebel`)
};

/**
* | output |
* | --- |
* | "e.g. Onion" |
*
* @param {Editor_Ingredient_Name_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const editor_ingredient_name_placeholder = /** @type {((inputs?: Editor_Ingredient_Name_PlaceholderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Ingredient_Name_PlaceholderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_editor_ingredient_name_placeholder(inputs)
	return en_editor_ingredient_name_placeholder(inputs)
});